import authReducer from "@funded-here-interface/common/src/features/auth/authSlice_Admin";
import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistStore, persistReducer, type PersistedState } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";

import BorbankSlice from "./features/merchant/bankSlice";
import bizBorSlice from "./features/merchant/biz";
import docBorrowerSlice from "./features/merchant/doc";
import BorrepSlice from "./features/merchant/rep";
import bankSlice from "./features/registration/bankSlice";
import bizSlice from "./features/registration/bizSlice";
import docSlice from "./features/registration/docSlice";
import repSlice from "./features/registration/repSlice";
import bulkSlice from "./features/sku/bulkSlice";

declare const __APP_VERSION__: string;

// One-time migration: clear orphaned localStorage persist key
// (admin switched from localStorage to sessionStorage for persistence)
if (localStorage.getItem("persist:root")) {
  localStorage.removeItem("persist:root");
}

const hashStringToNumber = (s: string): number => {
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = ((h << 5) - h + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
};

const persistConfig = {
  key: "root",
  storage: storageSession,
  whitelist: ["auth"], // Add other reducers you want to persist here
  version: hashStringToNumber(__APP_VERSION__),
  migrate: async (state: PersistedState, currentVersion: number): Promise<PersistedState> => {
    if (!state) return undefined;
    if (state._persist.version === currentVersion) return state;
    const { auth } = state as PersistedState & { auth?: unknown };
    return { auth, _persist: state._persist } as PersistedState;
  },
};
const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    auth: authReducer,
    biz: bizSlice,
    rep: repSlice,
    bank: bankSlice,
    doc: docSlice,
    bulk: bulkSlice,
    borBiz: bizBorSlice,
    BorBank: BorbankSlice,
    Borrep: BorrepSlice,
    bordoc: docBorrowerSlice,
  }),
);

const store = configureStore({
  reducer: persistedReducer,
});

const persistor = persistStore(store);

export { store, persistor };
export type RootState = ReturnType<typeof store.getState>;
